import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function assignTechnician(reqData) {
  try {
    const res = await post(`${URL.assignTechnicianToWOCategory}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
